export var isPassengerFareFragment = function (passengerFares) {
    return passengerFares.some(function (passengerFare) {
        return passengerFare.hasOwnProperty('travellers');
    });
};
